import { render, staticRenderFns } from "./teamquestion.vue?vue&type=template&id=10d43376&scoped=true&"
import script from "./teamquestion.vue?vue&type=script&lang=js&"
export * from "./teamquestion.vue?vue&type=script&lang=js&"
import style0 from "./teamquestion.vue?vue&type=style&index=0&id=10d43376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d43376",
  null
  
)

export default component.exports